import { A } from '@adornis/base/env-info.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { assertNexusPermission } from '@nsc/nexus-permissions/nexus-api/nexus-permission-gate.js';
import { NexusPermission } from '@nsc/nexus-permissions/platform-rbac/nexus-permissions.js';
import * as otrsAPI from '../server/client.js';

export const sendArticleToTicket = registerMutation({
  operationName: 'sendArticleToTicket',
  type: () => Boolean,
  resolve: (ticketID: string, subject: string, body: string) => async () => {
    await assertNexusPermission(NexusPermission.ArticleGeneration, 'article generation');
    if (!A.isDevelopment) throw new Error('Can only send article in dev env');
    await otrsAPI.addArticleToTicket(ticketID, { subject, body });
    return true;
  },
  params: [
    { name: 'ticketID', type: () => String },
    { name: 'subject', type: () => String },
    { name: 'body', type: () => String },
  ],
});
